"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "borgorose": {
    "cartore": [{
      "hkey": "d32a8681",
      "slug": "borgorose",
      "name": "Borgorose",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2a653dc6": [{
      "hkey": "3ee5071a",
      "slug": "colleviati-villette",
      "name": "Colleviati-Villette",
      "primary": true,
      "skipSearch": false
    }],
    "colleviati": [{
      "hkey": "3ee5071a",
      "slug": "colleviati-villette",
      "name": "Colleviati-Villette",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "56dca7ca": [{
      "hkey": "3ee5071a",
      "slug": "colleviati-villette",
      "name": "Colleviati-Villette",
      "primary": true,
      "skipSearch": false
    }],
    "villette": [{
      "hkey": "3ee5071a",
      "slug": "colleviati-villette",
      "name": "Colleviati-Villette",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "borgorose"
    }],
    "e05abb90": [{
      "hkey": "d32a8681",
      "slug": "borgorose",
      "name": "Borgorose",
      "primary": true,
      "skipSearch": false
    }]
  }
};
exports["default"] = _default;